import React, {Component} from 'react';
import Style from './FJDropboxSuccessModal.module.less';
import success from "../../../icon/success1.svg";
import FJButton from 'fj-components/FJButton'
import link from "../../../icon/link.svg";
import eye from "../../../icon/eye.svg";
import DeleteSVG from "../../../icon/delete-search.svg";
import facebook from "../../../icon/facebook.svg";
import twitter from "../../../icon/twitter.svg";
import InlineSVG from "react-inlinesvg";

class FJDropboxSuccessModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      designTitle: '',
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        designTitle: this.props.designTitle,
      });
    }
  }

  _deleteInputString = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this._videoName.focus();
    this.setState({designTitle: ""});
  };

  _mouseDown = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  _selectAllLink = () => {
    this._linkInput.focus();
    this._linkInput.select();
  };

  _onBlur = () => {
    if (document.selection && document.selection.empty) {
      document.selection.empty();
    } else if (window.getSelection) {
      let sel = window.getSelection();
      if (sel && sel.removeAllRanges)
        sel.removeAllRanges();
    }
  };

  _openLink = () => {
    window.open(this._getUrl(), "_blank");
  };

  /**
   * 分享到社交平台
   * @param type
   * @private
   */
  _openSocial = (type) => {
    let button;
    let url = this._getUrl();
    switch (type) {
      case 'facebook':
        window.open("https://www.facebook.com/sharer.php?u=" + url, "_blank");
        break;
      case 'twitter':
        window.open("http://twitter.com/share?url=" + url, "_blank");
        break;
      case 'email':
        button = document.querySelector('.at-svc-email');
        if (button) {
          if (window.addthis) {
            window.addthis.update('share', 'url', url);
            window.addthis.url = url;
            window.addthis.toolbox(".addthis_toolbox");
          }
          button.click();
        } else {
          console.log(`Error: addThis is not loaded`);
        }
        break;
    }
  };

  _inputChange = (e) => {
    let value = e.target.value;
    value = value.replace(/([\*\"\'<>\/])+/g, "");
    this.setState({designTitle: value});
  };

  _getUrl = () => {
    const {shareUrl} = this.props;
    const {designTitle} = this.state;
    return shareUrl + encodeURIComponent("&name=" + (designTitle === '' ? "Untitled" : designTitle));
  };

  /**
   * copy link 到剪切板
   * @private
   */
  _copy = () => {
    const {onCopy} = this.props;
    this._copyTextToClipBoard(this._getUrl(), this._tag);
    onCopy();
  };

  _copyTextToClipBoard = (text, tag) => {
    let _tag = tag;
    if (!_tag) {
      _tag = document.createElement('input');
      document.body.appendChild(_tag);
      window.queueMicrotask(() => {
        _tag.remove();
      });
    }
    _tag.value = text;
    _tag.select();
    document.execCommand('copy');
  };

  render() {
    const {copyText, sociaText, videoText, shareText, title} = this.props;
    const {designTitle} = this.state;
    let url = this._getUrl();
    return (
      <div className={Style.modal_content}>
        <div className={Style.icon}>
          <InlineSVG src={success} element="div"/>
        </div>
        <div className={Style.title}>{title}</div>
        <div className={Style.textInput}>
          <div className={Style.label}>{videoText}</div>
          <div className={Style.input + " " + Style.input_border}>
            <input ref={ele => {this._videoName = ele}}
                   className={Style.video_name}
                   maxLength={50}
                   value={designTitle}
                   onChange={this._inputChange}/>
            {designTitle && <div className={Style.delete_string_button}
                                 onClick={this._deleteInputString}
                                 onMouseDown={this._mouseDown}>
              <InlineSVG src={DeleteSVG} element='div'/>
            </div> }
          </div>
        </div>
        <div className={Style.textInput}>
          <div className={Style.label}>{shareText}</div>
          <div className={Style.input}>
            <div className={Style.linkShow}>
              <div><InlineSVG src={link}/></div>
              <textarea className={Style.textarea}
                        readOnly='readOnly'
                        value={url}/>
              <input ref={ele => {this._linkInput = ele}}
                     type="text"
                     value={url}
                     readOnly="readonly"
                     onBlur={this._onBlur}
                     onClick={this._selectAllLink}/>
              <div className={Style.btn}
                   onClick={this._openLink}>
                <InlineSVG src={eye} />
              </div>
            </div>
            <FJButton type='carved' text={copyText} onClick={this._copy} className={Style.copy_btn} textClass={Style.copy_text}/>
          </div>
        </div>
        <div>
          <div className={Style.label}>{sociaText}</div>
          <div className={Style.social}>
            <InlineSVG src={facebook} onClick={() => this._openSocial('facebook')}/>
            <InlineSVG src={twitter} onClick={() => this._openSocial('twitter')}/>
          </div>
        </div>
        <input ref={ele => {this._tag = ele}} style={{width: '1px', opacity: 0, overflow: 'hidden'}}/>
      </div>
    );
  }
}

export default FJDropboxSuccessModal;
